export async function initNewRelic() {
  if (import.meta.server) return
  const newrelic = await import('@newrelic/browser-agent/loaders/browser-agent')
  new newrelic.BrowserAgent({
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-d2a61cbf48d237d6ad0',
      applicationID: '601520016',
      sa: 1,
    },
    loader_config: {
      accountID: '3527736',
      trustKey: '3527736',
      agentID: '601520016',
      licenseKey: 'NRJS-d2a61cbf48d237d6ad0',
      applicationID: '601520016',
    },
  })
}
